import axios from 'axios'

export default {
    getAll: () => axios.get(`/push`),
    getById: id => axios.get(`/push/${id}`),
    create: formData => axios.post(`/push/create`, formData),
    // edit: formData => axios.put(`/push/edit`, formData),
    delete: id => axios.delete(`/push/delete/${id}`),
    changeStatus: formData => axios.patch(`/push/toggle_status`, formData)
}